export const UserDashboardRouteName = 'area-riservata-dashboard'
export const UserSavedSearchesRouteName = 'area-riservata-ricerche-salvate'
